module.exports = __webpack_public_path__ + "static/Truck33-ad53979c3a74a427f134a6ba1c4d3ae8.png";